/**
 * 时长单位
 * @type {{HOUR: string, MINUTE: string}}
 */
export const FreeUnit = {
  HOUR: 'HOUR',
  MINUTE: 'MINUTE',
  DAY: 'DAY',
  MONTH: 'MONTH',
}

export const FreeUnitEnum = {
  [FreeUnit.HOUR]: '小时',
  [FreeUnit.MINUTE]: '分钟',
  [FreeUnit.DAY]: '天',
  [FreeUnit.MONTH]: '月',
}

export const userTeamSource = {
  wx: "wechat",
  mp: "wechat",
  gh: "github",
  "user-from-github": "github",
  qw: "wecom",
}

export const userSourceCoding = "coding"

